import React from 'react';
import Icon from './AppIcon';

const LEGEND_ITEMS = [
  {
    status: 'Assigned',
    icon: 'Briefcase',
    color: 'text-blue-600',
    bg: 'bg-blue-100',
    dot: 'bg-blue-500',
    description: 'Has an assignment within the next 30 days (auto-set)'
  },
  {
    status: 'Available',
    icon: 'CheckCircle2',
    color: 'text-green-600',
    bg: 'bg-green-100',
    dot: 'bg-green-500',
    description: 'No assignment in the next 30 days (auto-set)'
  },
  {
    status: 'Maintenance',
    icon: 'Wrench',
    color: 'text-yellow-600',
    bg: 'bg-yellow-100',
    dot: 'bg-yellow-500',
    description: 'Under repair — manually set, not available for assignment'
  }
];

const ResourceStatusLegend = () => {
  return (
    <div className="bg-card rounded-lg border border-border px-4 py-3">
      <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
        <span className="text-xs font-semibold text-muted-foreground uppercase tracking-wider shrink-0">
          Status Legend
        </span>
        {LEGEND_ITEMS?.map((item) => (
          <div key={item?.status} className="flex items-center gap-2">
            <div className={`flex items-center gap-1.5 px-2 py-0.5 rounded-full ${item?.bg}`}>
              <Icon name={item?.icon} size={12} className={item?.color} />
              <span className={`text-xs font-medium ${item?.color}`}>{item?.status}</span>
            </div>
            <span className="text-xs text-muted-foreground hidden sm:inline">{item?.description}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ResourceStatusLegend;
